import {
    GETUSERWITHDRWALCOUNT_SUCCESS,
    GETUSERWITHDRWALCOUNT_FAILED,
    RESET_GETUSERWITHDRWALCOUNT,
    LOADING_GETUSERWITHDRWALCOUNT,
    NETWORK_ERROR_GETUSERWITHDRWALCOUNT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETUSERWITHDRWALCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETUSERWITHDRWALCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETUSERWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETUSERWITHDRWALCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
